module.exports = __webpack_public_path__ + "img/Dantam Makeover 19.0bcd6a43.jpg";